import Moment from "moment";
import { auth } from "../services/auth";
import { useState, useEffect } from "react";
import { getTicketStatus, addTicketComment, updateTicketStatus } from "../services/ticketComment";
import styles from "../css/ticket.module.css";
import Loader from "../shared/Loader";

function TicketComment({ ticket, selectTicket, newTicket, setNewTicket, closePopup }) {
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [hasError, setHasError] = useState(false);
  const user = auth().getUser();
  const isAdmin = auth().isAdmin();
  const [ticketStatuses, setTicketStatuses] = useState({});
  const [selectedStatus, setSelectedStatus] = useState();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [successStatus, setSuccessStatus] = useState("");
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const [hasErrorStatus, setHasErrorStatus] = useState(false);
  const token = auth().getToken();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (isAdmin) {
      getTicketStatus(config).then((response) => {
        setTicketStatuses(response.data);
      });
    }
  }, [isAdmin]);

  const saveStatus = () => {
    setIsLoadingStatus(true);
    updateTicketStatus(ticket, selectedStatus, config)
      .then((response) => {
        setNewTicket(!newTicket);
        setSuccessStatus(true);
      })
      .catch((error) => {
        setHasErrorStatus(true);
        setSuccessStatus(false);
        setErrorStatus(error.message);
      })
      .finally(() => {
        setIsLoadingStatus(false);
      });
  };

  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const addComment = (value) => {
    setIsLoading(true);
    addTicketComment(user, ticket, title, description, config)
      .then((response) => {
        selectTicket(value);
        setDescription("");
        setTitle("");
        setHasError(false);
        setSuccess(true);
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section>
      {" "}
      {ticket != null ? (
        <div className="flex flex-col">
          {isAdmin ? (
            <div className="flex flex-col lg:flex-row gap-5 items-center">
              <label className="font-semibold">Change Status:</label>
              <div className="flex flex-row gap-5 items-center">
                <select
                  className="border w-48 h-8 px-2 py-1 rounded-2xl bg-white border-pink-350"
                  onChange={handleChange}
                >
                  {ticketStatuses.length > 0
                    ? ticketStatuses.map((stat, idx) => (
                        <option key={stat.id} value={stat?.id}>
                          {stat?.title}
                        </option>
                      ))
                    : null}
                </select>
                <button
                  className={`my-3 px-5 py-1 ${styles.ticketBtnSave}`}
                  id={ticket?.id}
                  onClick={(e) => saveStatus(e.target.id)}
                >
                  Save
                </button>
                <div>
                  <div
                    className={`flex flex-col ${
                      isLoadingStatus
                        ? "justify-center"
                        : hasErrorStatus
                        ? "justify-center"
                        : "justify-center"
                    }`}
                  >
                    {isLoadingStatus ? (
                      <div className="my-5 mx-20">
                        {" "}
                        <Loader styles={"w-12 h-12"}></Loader>{" "}
                      </div>
                    ) : hasErrorStatus ? (
                      <div
                        key={Math.random()}
                        className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                        role="alert"
                      >
                        <svg
                          aria-hidden="true"
                          className="flex-shrink-0 inline w-5 h-5 mr-3"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        <div>
                          <span className="font-medium">Error!</span> {errorStatus}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {successStatus ? (
                    <div
                      className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
                      role="alert"
                    >
                      <svg
                        aria-hidden="true"
                        className="flex-shrink-0 inline w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div>
                        <span className="font-medium">Success!</span> Sucessfully changed status!
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
          <div className="flex flex-col lg:flex-start gap-5 h-auto max-h-max">
            <div className="flex flex-col lg:flex-row lg:gap-2">
              <label className="font-semibold">Subject: </label>
              <span className=" text-lg">{ticket?.title}</span>
            </div>
            <div className="flex flex-col lg:flex-row lg:gap-2">
              <label className="font-semibold">Message: </label>
              <span className="">{ticket?.description}</span>
            </div>
            {ticket?.email ? (
              <div className="flex flex-col lg:flex-row lg:gap-2">
                <label className="font-semibold">Created by:</label>
                <span className="font-semibold">{ticket?.email}</span>
              </div>
            ) : null}
            <div className="flex flex-col lg:flex-row lg:gap-2">
              <label className="font-semibold">Created on:</label>
              <span className="font-semibold text-pink-350">
                {Moment(ticket?.created).format("YYYY-MM-DD HH:mm")}
              </span>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row w-full gap-5 items-center lg:items-start">
            <div className="flex flex-col w-2/3 lg:w-1/2">
              {ticket?.ticketComments != null && ticket?.ticketComments.length > 0 ? (
                <>
                  <span className="font-semibold">Comments:</span>
                  <div className="overflow-y-scroll scrollbar min-h-min max-h-96 border border-transparent border-t-gray-350 border-b-gray-350">
                    <div className="flex flex-col bg-white rounded-lg py-1">
                      {ticket?.ticketComments.map((item, idx) => (
                        <div
                          key={item.id}
                          className={`flex flex-col w-2/3 bg-pink-100 p-3 rounded-lg max-w-lg rounded-bl-lg mx-5 my-2 ${
                            item.userId != user.id
                              ? "bg-pink-100 self-start"
                              : "bg-blue-100 self-end"
                          }`}
                        >
                          <div className="p-1">#{idx + 1}</div>
                          <div>{item.description}</div>
                          <div className="text-pink-350">
                            {Moment(item.created).format("YYYY-MM-DD HH:mm")}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex flec-row text-center justify-center self-center p-32 text-lg">
                  No comments yet
                </div>
              )}
            </div>
            <div className="flex flex-col gap-5 w-2/3 lg:w-1/2">
              <h2 className="text-xl font-bold gap-5">Add comment</h2>
              <div className="flex flex-col gap-5">
                <label className="uppercase font-semibold" htmlFor="description">
                  Description
                </label>
                <textarea
                  className={`${styles.ticketDescription}`}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  type="textarea"
                  name="description"
                  id="description"
                  required
                />
              </div>
              <div className="flex flex-col lg:flex-row self-center gap-5">
                <button
                  className={`${styles.ticketCommentBtn}`}
                  id={ticket.id}
                  onClick={(e) => addComment(e.target.id)}
                  disabled={!description}
                  type="submit"
                  value="Add post"
                >
                  Add comment
                </button>
                <button
                  className={`${styles.ticketCommentBtn}`}
                  id={ticket.id}
                  onClick={(e) => closePopup()}
                  type="submit"
                  value="Close"
                >
                  Close
                </button>
              </div>
              <div>
                <div
                  className={`flex flex-col ${
                    isLoading ? "justify-center" : hasError ? "justify-center" : "justify-center"
                  }`}
                >
                  {isLoading ? (
                    <div className="my-5 mx-20">
                      {" "}
                      <Loader styles={"w-12 h-12"}></Loader>{" "}
                    </div>
                  ) : hasError ? (
                    <div
                      key={Math.random()}
                      className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                      role="alert"
                    >
                      <svg
                        aria-hidden="true"
                        className="flex-shrink-0 inline w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div>
                        <span className="font-medium">Error!</span> {error}
                      </div>
                    </div>
                  ) : null}
                </div>
                {success ? (
                  <div
                    className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
                    role="alert"
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 inline w-5 h-5 mr-3"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <div>
                      <span className="font-medium">Success!</span> Sucessfully added ticket!
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default TicketComment;
